import endpoints from "../config/endpoints";
import api from "../config/axios";

export const userLogin = async (phoneNumber) => {
    const response = await api.post(`${endpoints.User.UserLogin}?phoneNumber=${phoneNumber}`);

    return {
        data: response.data.data || null,
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
};

export const verifyUserOTP = async (otp, phoneNumber, randomCode) => {
    const response = await api.post(
        `${endpoints.User.VerifyUserOTP}?otp=${otp}`,
        {
            phoneNumber: phoneNumber,
            randomCode: randomCode
        }
    );

    return {
        data: response.data.data || null,
        status: response.data.status,
        statusCode: response.data.statusCode,
        message: response.data.message,
    };
};

export const getUserDetailsById = async (userId) => {
    try {
        const response = await api.get(`${endpoints.User.GetUserDetailsById}?id=${userId}`);
        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching user details:', error);
        throw error;
    }
};

export const updateUserDetails = async (userId, userData) => {
    try {
        const response = await api.put(`${endpoints.User.UpdateUserDetails}/${userId}`, userData);
        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error updating user details:', error);
        throw error;
    }
};

export const submitContactDetails = async (contactData) => {
    try {
        const response = await api.post(`${endpoints.User.SubmitContactDetails}`, contactData);
        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error submit contact details:', error);
        throw error;
    }
};

const userService = {
    userLogin,
    verifyUserOTP,
    getUserDetailsById,
    updateUserDetails,
    submitContactDetails
};

export default userService;
